module.exports = __webpack_public_path__ + "static/media/ic_collapse_arrow_primary.c0f343d1.svg";